import teamsApi from "@/api/teams"
import events from "@/bl-events/index"

const state = {
  error: null,
  maxSeats: null,
  filledSeats: null,
  hasTeam: null,
  isActiveOrganisation: null,
  resubscribePath: null
}

const getters = {
  maxSeats: (state) => {
    return state.maxSeats
  }
}

const mutations = {
  hasTeam: (state, payload) => {
    state.hasTeam = payload
  },
  maxSeats: (state, payload) => {
    state.maxSeats = payload
  },
  filledSeats: (state, payload) => {
    state.filledSeats = payload
  },
  error: (state, payload) => {
    state.error = payload
  },
  isActiveOrganisation: (state, payload) => {
    state.isActiveOrganisation = payload
  },
  resubscribePath: (state, payload) => {
    state.resubscribePath = payload
  }
}

const actions = {
  loadTeam: ({ commit }) => {
    return teamsApi
      .loadTeam()
      .then((res) => {
        if (res.status === "error") {
          throw res.message
        } else {
          commit("hasTeam", true)
          commit("filledSeats", res.filledSeats)
          commit("maxSeats", res.maxSeats)
          commit("isActiveOrganisation", res.isActiveOrganisation)
          commit("resubscribePath", res.resubscribePath)

          events.track("teams_settings_members_shown", "1-show", res.filledSeats)
        }
      })
      .catch((err) => {
        commit("hasTeam", false)
        commit("error", err)
      })
      .finally(() => {
        events.emit("page-loaded")
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
